import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqItems } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于本站的内容、更新频率与浏览方式，这里一次说清楚。"
          align="center"
        />
        <div className="mt-10 max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.question}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-900">
                    {item.question}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-primary-500 ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}